import React, { useEffect, useState } from 'react';
import InputField from '../../../../../../component/form/FormInput';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import InputSelect from '../../../../../../component/inputSelect/InputSelect';
import PageLoader from '../../../../../../component/PageLoader';
import { toast } from 'react-toastify';

export default function FieldCustomization({
	isCreateForm,
	customFieldForm,
	setCustomFieldForm,
	setCustomFieldError,
	customFieldError,
	productLoader,
	setProductLoader,
}) {
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};
	const [bulkAction, setBulkAction] = useState([]);
	const [sortDirection, setSortDirection] = useState({});
	const onRowClick = (id) => {};

	const [customFieldTable, setCustomFieldTable] = useState([
		{
			field_name: 'Lorem Ipsom',
			data_type: 'Lorem Ipson',
			mandatory: 'Lorem Ipson',
			status: 1,
		},
		{
			field_name: 'Lorem Ipsom',
			data_type: 'Lorem Ipson',
			mandatory: 'Lorem Ipson',
			status: 1,
		},
		{
			field_name: 'Lorem Ipsom',
			data_type: 'Lorem Ipson',
			mandatory: 'Lorem Ipson',
			status: 1,
		},
	]);
	const dataTypeList = [
		{
			key: 'Text Box (Single-Line)',
			value: 'Text Box (Single-Line)',
		},
		{
			key: 'Email',
			value: 'Email',
		},
		{
			key: 'URL',
			value: 'URL',
		},
		{
			key: 'Phone',
			value: 'Phone',
		},
		{
			key: 'Number',
			value: 'Number',
		},
		{
			key: 'Decimal',
			value: 'Decimal',
		},
		{
			key: 'Amount',
			value: 'Amount',
		},
		{
			key: 'Percent',
			value: 'Percent',
		},
		{
			key: 'Date',
			value: 'Date',
		},
		{
			key: 'Date and Time',
			value: 'Date and Time',
		},
		{
			key: 'Check Box',
			value: 'Check Box',
		},
		{
			key: 'Auto-Generate Number',
			value: 'Auto-Generate Number',
		},
		{
			key: 'Dropdown',
			value: 'Dropdown',
		},
		{
			key: 'Multi-Select',
			value: 'Multi-Select',
		},
		{
			key: 'Lookup',
			value: 'Lookup',
		},
		{
			key: 'Text Box (Multi-Line)',
			value: 'Text Box (Multi-Line)',
		},
		{
			key: 'Attachment',
			value: 'Attachment',
		},
		{
			key: 'Image',
			value: 'Image',
		},
	];

	const handleFormData = (key, value, required) => {
		setCustomFieldForm((prev) => ({
			...prev,
			[key]: value,
		}));
		var newError = { ...setCustomFieldError };
		if (required) {
			if (value === '' || value === null || value === undefined) {
				newError[key] =
					`Please ${key === 'data_type' ? 'select valid' : 'enter'} ${key.split('-').joint('')} ${key === 'data_type' ? 'from the list' : 'in the field'} `;
			} else {
				delete newError[key];
			}
		}
	};
	const getFieldCustomisationTable = () => {
		try {
			// const res = await
		} catch (error) {
			toast.error(error.message || 'Somthing went wrong!');
		}
	};

	useEffect(() => {
		if (!isCreateForm) {
			getFieldCustomisationTable();
		}
	}, [isCreateForm]);

	// const fieldCustomColumns = [
	// 	{
	// 		field: 'FIELD NAME',
	// 		headerClass: 'HeaderBg',
	// 		suppressSizeToFit: true,
	// 		minWidth: 150,
	// 		flex: 1,
	// 		cellClass: 'left-align',
	// 		headerComponent: () => {
	// 			return (
	// 				<div
	// 					style={{
	// 						width: '100%',
	// 						paddingTop: '10px',
	// 						cursor: 'pointer',
	// 					}}
	// 					onClick={() => sortDataList({ orderBy: 'field_name', sortBy: 'asc' })}
	// 				>
	// 					<div
	// 						style={{
	// 							width: '55px',
	// 						}}
	// 					>
	// 						<p
	// 							style={{
	// 								display: 'flex',
	// 								alignItems: 'center',
	// 								color: 'black',
	// 							}}
	// 						>
	// 							FIELD NAME
	// 							<span
	// 								style={{
	// 									fontSize: '18px',
	// 									fontWeight: '800',
	// 								}}
	// 							>
	// 								{sortIconMap[sortDirection?.field_name]}
	// 							</span>
	// 						</p>
	// 					</div>
	// 				</div>
	// 			);
	// 		},
	// 	},
	// 	{
	// 		field: 'DATA TYPE',
	// 		headerClass: 'HeaderBg left-align',
	// 		suppressSizeToFit: true,
	// 		minWidth: 140,
	// 		maxWidth: 140,
	// 		flex: 1,
	// 		cellClass: 'left-align',
	// 		headerComponent: () => {
	// 			return (
	// 				<div
	// 					style={{
	// 						width: '100%',
	// 						paddingTop: '10px',
	// 						cursor: 'pointer',
	// 					}}
	// 					onClick={() => sortDataList({ orderBy: 'data_type', sortBy: 'asc' })}
	// 				>
	// 					<div
	// 						style={{
	// 							width: '55px',
	// 						}}
	// 					>
	// 						<p
	// 							style={{
	// 								display: 'flex',
	// 								alignItems: 'center',
	// 								color: 'black',
	// 							}}
	// 						>
	// 							DATA TYPE
	// 							<span
	// 								style={{
	// 									fontSize: '18px',
	// 									fontWeight: '800',
	// 								}}
	// 							>
	// 								{sortIconMap[sortDirection?.data_type]}
	// 							</span>
	// 						</p>
	// 					</div>
	// 				</div>
	// 			);
	// 		},
	// 	},
	// 	{
	// 		field: 'MANDATORY',
	// 		suppressSizeToFit: true,
	// 		headerClass: 'HeaderBg',
	// 		flex: 1,
	// 		minWidth: 150,
	// 		cellClass: 'left-align',
	// 		headerComponent: () => {
	// 			return (
	// 				<div
	// 					style={{
	// 						width: '100%',
	// 						paddingTop: '10px',
	// 						cursor: 'pointer',
	// 					}}
	// 					onClick={() => sortDataList({ orderBy: 'mandatory', sortBy: 'asc' })}
	// 				>
	// 					<div
	// 						style={{
	// 							width: '55px',
	// 						}}
	// 					>
	// 						<p
	// 							style={{
	// 								display: 'flex',
	// 								alignItems: 'center',
	// 								color: 'black',
	// 							}}
	// 						>
	// 							MANDATORY
	// 							<span
	// 								style={{
	// 									fontSize: '18px',
	// 									fontWeight: '800',
	// 								}}
	// 							>
	// 								{sortIconMap[sortDirection?.mandatory]}
	// 							</span>
	// 						</p>
	// 					</div>
	// 				</div>
	// 			);
	// 		},
	// 	},
	// 	{
	// 		field: 'Status',
	// 		headerClass: 'HeaderBg',
	// 		suppressSizeToFit: true,
	// 		minWidth: 220,
	// 		maxWidth: 300,
	// 		flex: 1,
	// 		cellClass: 'left-align',
	// 		cellRenderer: (params) => {
	// 			const status = params.data?.status || '';
	// 			let statusCode = '';

	// 			switch (status) {
	// 				case 0:
	// 					statusCode = '#DC3545';
	// 					break;
	// 				case 1:
	// 					statusCode = '#6AA247';
	// 					break;

	// 				default:
	// 					statusCode = '#DC3545';
	// 					break;
	// 			}

	// 			return (
	// 				<div
	// 					style={{
	// 						display: 'flex',
	// 						alignItems: 'center',
	// 						justifyContent: 'center',
	// 						fontSize: '14px',
	// 						margin: '8px 0px',
	// 						color: statusCode,
	// 					}}
	// 				>
	// 					{status === 0 ? 'Inactive' : 'Active'}
	// 				</div>
	// 			);
	// 		},
	// 	},
	// ];

	return (
		<div>
			{isCreateForm ? (
				<div className="p-3">
					<div className="row align-items-center my-1">
						<div className="d-flex col-3 col-lg-2 gap-1 align-items-center">
							<div className="text-sm font-medium my-3">Label Name</div>
							<div className="fs-6 fw-light text-danger">*</div>
						</div>
						<div className="col-8 col-lg-3">
							<InputField
								label=""
								placeholder="Label Name"
								type="text"
								required={true}
								value={customFieldForm.label_name}
								onChange={(value) => handleFormData('label_name', value, true)}
								error={customFieldError?.label_name}
							/>
						</div>
					</div>
					<div className="row align-items-center my-1">
						<div className="d-flex col-3 col-lg-2 gap-1 align-items-center">
							<div className="text-sm font-medium my-3">Data Type</div>
							<div className="fs-6 fw-light text-danger">*</div>
						</div>
						<div className="col-8 col-lg-3">
							<InputSelect
								options={dataTypeList}
								label=""
								placeholder="Select Data Type"
								error={customFieldError?.state_id}
								returnInputValue={false}
								value={customFieldForm.data_type}
								onChange={(value) => {
									handleFormData('data_type', '', true);
								}}
								onSelect={(options) => {
									handleFormData('data_type', options.value, true);
								}}
							/>
						</div>
					</div>
					<div className="d-flex align-items-center my-1">
						<div className="d-flex col-3 col-lg-2 gap-1 align-items-center">
							<div className="text-sm font-medium my-3">Is Mandatory</div>
						</div>
						<div className="col-8 col-lg-3">
							<div className="d-flex gap-4">
								<div className="my-2 d-flex align-items-center gap-2">
									<input
										type="radio"
										value={customFieldForm.is_mandatory}
										checked={customFieldForm.is_mandatory}
										id="mandatory_yes"
										name="mandatory"
										onChange={(e) => {
											var value = e.target.checked;
											handleFormData('is_mandatory', value);
										}}
										className="form-radio-input m-2 p-2"
									/>
									<label
										htmlFor="yes"
										className="fw-bold fs-5"
									>
										Yes
									</label>
								</div>
								<div className="my-2 d-flex align-items-center gap-2">
									<input
										type="radio"
										value={!customFieldForm.is_mandatory}
										checked={!customFieldForm.is_mandatory}
										id="mandatory_no"
										name="mandatory"
										onChange={(e) => {
											var value = e.target.checked;
											handleFormData('is_mandatory', !value);
										}}
										className="form-radio-input m-2 p-2"
									/>
									<label
										htmlFor="no"
										className="fw-bold fs-5"
									>
										No
									</label>
								</div>
							</div>
						</div>
					</div>
					<div className="d-flex align-items-center my-1">
						<div className="d-flex col-3 col-lg-2 gap-1 align-items-center">
							<div className="text-sm font-medium my-3">Display in Portal</div>
						</div>
						<div className="col-8 col-lg-3">
							<div className="d-flex gap-4">
								<div className="my-2 d-flex align-items-center gap-2">
									<input
										type="radio"
										value={customFieldForm.status}
										checked={customFieldForm.status}
										id="status_yes"
										name="status"
										onChange={(e) => {
											var value = e.target.checked;
											handleFormData('status', value);
										}}
										className="form-radio-input m-2 p-2"
									/>
									<label
										htmlFor="yes"
										className="fw-bold fs-5"
									>
										Yes
									</label>
								</div>
								<div className="my-2 d-flex align-items-center gap-2">
									<input
										type="radio"
										value={!customFieldForm.status}
										checked={!customFieldForm.status}
										id="status_no"
										name="status"
										onChange={(e) => {
											var value = e.target.checked;
											handleFormData('status', !value);
										}}
										className="form-radio-input m-2 p-2"
									/>
									<label
										htmlFor="no"
										className="fw-bold fs-5"
									>
										No
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : productLoader.isLoader && productLoader.isGetDataFieldCustomisation ? (
				<PageLoader />
			) : (
				<div className="p-3">
					<table className="currency-table">
						<thead>
							<tr>
								{['FIELD NAME', 'DATA TYPE', 'MANDATORY', 'STATUS'].map((item) => (
									<th>{item}</th>
								))}
							</tr>
						</thead>
						<tbody>
							{customFieldTable.map((data, index) => (
								<tr key={index}>
									<td>{data.field_name}</td>
									<td>{data.data_type}</td>
									<td>{data.mandatory}</td>
									<td style={{ color: data.status === 0 ? '#DC3545' : '#6AA247' }}>
										{data.status === 0 ? 'Inactive' : 'Active'}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
}
